import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { CROP_FIELDS_AND_WORKS_INDEX } from '../../../router/routes';
import { route } from '../../../services/utils';
import DashboardCard from '../components/dashboard-card';
import DashboardTitle from '../components/dashboard-title';
import WorksList from './list';
import { faClipboardCheck } from '@fortawesome/pro-solid-svg-icons';

export default function WorksCard() {
  const { t } = useTranslation();
  const { farmId, season } = useSelector((state: RootState) => ({
    farmId: state.global?.farm?.id,
    season: state.global?.season,
  }));

  return (
    <DashboardCard dataName={`works-list`}>
      <DashboardTitle
        title={t('pages.dashboard.works.heading')}
        link={route(CROP_FIELDS_AND_WORKS_INDEX, {
          farmId: farmId,
          season: season,
          tab: 'work-overview',
        })}
        icon={faClipboardCheck}
      />
      <WorksList />
    </DashboardCard>
  );
}
